<template>
        <v-menu v-model="timePicker" :close-on-content-click="false">
            <template v-slot:activator="{ props }">
                <v-text-field
                    :data-cy="`${dataCyPrefix}-time`"
                    v-model="formattedTime"
                    :label="$t('formFields.timeInterval')"
                    :rules="timeRangeRules"
                    readonly
                    :disabled="disabled"
                    v-bind="props"
                    hide-details="auto"
                />
            </template>
            <v-card>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-time-picker
                                v-model="modelValue.timeStart"
                                format="24hr"
                                scrollable
                                :min="min"
                                :max="max"
                                :title="$t('formFields.selectStartTime')"
                                @update:modelValue="updateTime('timeStart', $event)"
                            />
                        </v-col>
                        <v-col>
                            <v-time-picker
                                v-model="modelValue.timeEnd"
                                format="24hr"
                                scrollable
                                :min="effectiveEndMin"
                                :max="max"
                                :title="$t('formFields.selectEndTime')"
                                @update:modelValue="updateTime('timeEnd', $event)"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-menu>
</template>

<script>
import { timeToMinutes } from "@/utils";

export default {
    props: {
        modelValue: Object,
        dataCyPrefix: String,
        min: { type: String, default: null },
        max: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            timePicker: false,
        };
    },
    computed: {
        formattedTime() {
            return this.modelValue.timeStart && this.modelValue.timeEnd
                ? `${this.modelValue.timeStart} - ${this.modelValue.timeEnd}`
                : "";
        },
        effectiveEndMin() {
            return this.modelValue?.timeStart || this.min;
        },
        timeRangeRules() {
            const rules = [];
            if (this.required) {
                rules.push((v) => {
                    const { timeStart, timeEnd } = this.modelValue || {};
                    return (!!timeStart && !!timeEnd) || this.$t("validation.required");
                });
            }
            if (this.min || this.max) {
                rules.push(this.validateTimeRange);
            }
            return rules;
        },
    },
    methods: {
        validateTimeRange() {
            const { timeStart, timeEnd } = this.modelValue || {};
            if (!timeStart || !timeEnd) return true;
            const startMin = timeToMinutes(timeStart);
            const endMin = timeToMinutes(timeEnd);
            const minBound = timeToMinutes(this.min ?? "00:00");
            const maxBound = timeToMinutes(this.max ?? "23:59");
            if (startMin < minBound || startMin > maxBound || endMin < minBound || endMin > maxBound) {
                return this.$t("validation.timeOutOfRange");
            }
            return true;
        },
        updateTime(field, value) {
            this.$emit("update:modelValue", {
                ...this.modelValue,
                [field]: value,
            });
            if (this.modelValue.timeStart && this.modelValue.timeEnd) {
                this.$nextTick(() => {
                    this.timePicker = false;
                });
            }
        },
    },
};
</script>
